export default {
  vision_save__: "FraudVision 帮你一键搞定论坛、群聊、频道、博客，让你省下大把摸索和翻帖的时间。".toUpperCase(),
  say_goodbuy__: "和那些界面停留在2012年、运营团队完全不懂社区需求的老古董网站说拜拜吧。".toUpperCase(),
  top_projects: "热门项目精选".toUpperCase(),
  lorem_ipsum__: "Lorem ipsum dolor sit amet, consectetuer adipiscing elit.",
};
